import React from 'react';
import { motion } from 'framer-motion';
import { HelpCircle } from 'lucide-react';
import { useOnboarding } from '../../context/OnboardingContext';

const HelpButton = () => {
  const { setShowHelpCenter, currentTour } = useOnboarding();

  // Don't show button during an active tour
  if (currentTour) return null;

  return (
    <motion.button
      initial={{ scale: 0, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      transition={{ delay: 1, type: 'spring', stiffness: 260, damping: 20 }}
      whileHover={{ scale: 1.1 }}
      whileTap={{ scale: 0.95 }}
      onClick={() => setShowHelpCenter(true)}
      className="fixed bottom-20 right-6 z-[9980] w-14 h-14 bg-gradient-to-r from-orange-500 to-red-500 rounded-full shadow-lg flex items-center justify-center text-white hover:shadow-xl transition-shadow group"
      data-testid="help-button"
    >
      <HelpCircle className="w-6 h-6" />
      
      {/* Tooltip */}
      <span className="absolute right-full mr-3 px-3 py-1.5 bg-gray-900 text-white text-sm rounded-lg whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none">
        Need help?
      </span>
      
      {/* Pulse animation */}
      <span className="absolute inset-0 rounded-full bg-orange-500 animate-ping opacity-20" />
    </motion.button>
  );
};

export default HelpButton;
